/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { css, FlattenSimpleInterpolation } from 'styled-components';

export interface IDevice {
	common(size: number): (...args: any[]) => FlattenSimpleInterpolation;
}

const device: IDevice = {
	common(size) {
		return (...args) => css`
			@media screen and (max-width: ${size}px) {
				${css.call(undefined, ...args)}
			}
		`;
	},
};

export default device;
